import { render, staticRenderFns } from "./FAccordionItem.vue?vue&type=template&id=dea376c6&"
import script from "./FAccordionItem.vue?vue&type=script&lang=js&"
export * from "./FAccordionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports